import React, { FC, useEffect, useMemo, useState } from 'react';
import './style.css';
import { FilterContent, FilterItem } from './filter-item';
import { FilterField, FilterFields, FilterValues } from './filter-panel-types';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';

type Props = {
  fields: FilterFields;
  value?: FilterValues;
  onChange?: (value?: FilterValues) => void;
};

export const FilterPanel: FC<Props> = ({ fields, onChange, value }) => {
  const items: any = useMemo(
    () =>
      fields
        .filter(
          (f) =>
            f.hidden && value?.find((v) => v.name === f.name) === undefined,
        )
        .map((f) => ({
          key: f.name,
          label: f.label,
          field: f,
        })),
    [fields, value],
  );
  const [customField, setCustomField] = useState<FilterField>();
  const [popVisible, setPopVisible] = useState<boolean>(false);
  useEffect(() => {
    if (!popVisible) {
      setCustomField(undefined);
    }
  }, [popVisible]);
  return (
    <div className="filter-panel">
      {fields
        .filter(
          (f) =>
            !f.hidden || value?.find((v) => v.name === f.name) !== undefined,
        )
        .map((field, i) => (
          <FilterItem
            key={i}
            field={field}
            value={value?.find((v) => v.name === field.name)}
            onChange={(v) => {
              const existing = (value ?? []).filter(
                (v) => v.name !== field.name,
              );
              if (v) {
                existing.push(v);
              }
              onChange?.(existing.length === 0 ? undefined : existing);
            }}
          />
        ))}

      {items.length > 0 && (
        <Popover
          trigger="click"
          open={popVisible}
          placement="bottomLeft"
          onOpenChange={setPopVisible}
          content={
            customField ? (
              <FilterContent
                field={customField}
                onChange={(v) => {
                  const existing = (value ?? []).filter(
                    (v) => v.name !== customField.name,
                  );
                  if (v) {
                    existing.push(v);
                  }
                  onChange?.(existing.length === 0 ? undefined : existing);
                  setCustomField(undefined);
                  setPopVisible(false);
                }}
              />
            ) : (
              <div className="filter-more-items">
                {items.map((item: any) => (
                  <Button
                    type="text"
                    onClick={() => setCustomField(item.field)}
                    key={item.key}
                  >
                    <div style={{ width: '100%', textAlign: 'left' }}>
                      {item.label}
                    </div>
                  </Button>
                ))}
              </div>
            )
          }
        >
          <div className="filter-item filter-label">
            <Button
              className="filter-item-button"
              shape="circle"
              type="text"
              icon={<PlusCircleOutlined />}
            />
            More
          </div>
        </Popover>
      )}
    </div>
  );
};
